const styles = `:host {
  font: var(--goto-body-small);
  color: var(--goto-type-color-inverted);
  box-sizing: border-box;
  display: flex;
  gap: var(--goto-spacing-02);
  justify-content: center;
  align-items: center;
  padding-inline: var(--goto-spacing-03);
  padding-block: var(--goto-spacing-01);
  position: relative;
  --goto-icon-size: var(--goto-spacing-05);
  --goto-icon-color: var(--goto-icon-color-inverted);
}
:host .banner-close-button {
  height: 24px;
  width: 24px;
  display: inline-flex;
  background: none;
  border: none;
  color: var(--goto-interactive-color-neutral-default);
  position: relative;
  margin-left: auto;
  justify-content: center;
  align-items: center;
  --goto-icon-button-icon-color: var(--goto-icon-color-inverted);
  --goto-icon-color: var(--goto-icon-color-inverted);
}
:host .banner-close-button::part(control) {
  height: 24px;
  width: 24px;
}
:host .banner-main-content {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  gap: var(--goto-spacing-02);
}
:host .banner-main-content[data-closeable=true] {
  margin-left: auto;
}
:host .banner-main-content[data-multiline=true] {
  margin-left: 0;
  margin-right: auto;
}
:host .banner-actions {
  display: flex;
  align-items: baseline;
  gap: var(--goto-spacing-02);
}
:host .banner-actions[data-display-dismiss=false] chameleon-button.dismissButton {
  display: none;
}

chameleon-button[name=action-button-mobile] {
  display: none;
}

@media all and (max-width: 48rem) {
  :host {
    gap: var(--goto-spacing-04);
    justify-content: flex-start;
    padding: var(--goto-spacing-04);
  }
  :host ::slotted(a[slot=action]),
:host ::slotted(chameleon-link[slot=action]) {
    display: none !important;
  }
  :host chameleon-button[name=action-button-mobile] {
    display: inline-flex;
    margin-left: auto;
  }
  :host .banner-close-button {
    margin-left: 0;
  }
  :host .banner-main-content {
    justify-content: flex-start;
    gap: var(--goto-spacing-02);
  }
  :host .banner-main-content[data-closeable=true] {
    margin-left: 0;
  }
}
::slotted(p) {
  margin: 0;
}

:host([variant=info]) {
  background-color: var(--goto-surface-color-inverted);
}

:host([variant=success]) {
  background-color: var(--goto-surface-color-success-default);
}

:host([variant=danger]) {
  background-color: var(--goto-surface-color-danger-default);
}

:host([variant=dark]) {
  background-color: var(--goto-surface-color-inverted);
}

:host([variant=neutral]) {
  background-color: var(--goto-surface-color-inverted);
}

::slotted(a[slot=action]),
::slotted(chameleon-link[slot=action]) {
  font: var(--goto-body-small);
  color: var(--goto-type-color-inverted);
  cursor: pointer;
  margin-left: -var(--goto-spacing-02);
  --goto-link-color: var(--goto-type-color-inverted);
  --goto-link-text-decoration: underline;
  text-decoration: var(--goto-link-text-decoration);
}

:host([multiline]) {
  gap: var(--goto-spacing-04);
  justify-content: flex-start;
  padding: var(--goto-spacing-04);
  flex-direction: column;
  align-items: flex-end;
}
:host([multiline]) .banner-main-content {
  align-items: flex-start;
}

:host([multiline]) ::slotted(a[slot=action]),
:host([multiline]) ::slotted(chameleon-link[slot=action]) {
  display: none !important;
}

:host([has-action=false]) .banner-close-button {
  height: 24px;
  width: 24px;
  display: inline-flex;
  background: none;
  border: none;
  color: var(--goto-interactive-color-neutral-default);
  position: relative;
  margin-left: auto;
  justify-content: center;
  align-items: center;
  --goto-icon-button-icon-color: var(--goto-icon-color-inverted);
}`; export default styles;